export default __webpack_public_path__ + "static/media/firstServe-category-icon.f668ef2f.svg";